import { ILanguage, RootState } from '@checkout/state';
import * as React from 'react';
import { ChangeEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { languageChangeRequest } from '../../../reducers/checkout';
import { DropDown } from '../../presentational';
import messages from './../../../i18n/base-en';

interface IOwnProps {
  languages: ILanguage[];
}

interface IConnectedProps {
  language?: string;
}

interface IConnectetDispatchProps {
  languageChangeRequest: typeof languageChangeRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class LangSwitcher extends React.Component<Props, {}> {

  handleChange = (event: ChangeEvent<any>) => {
    const { value } = event.target;
    this.props.languageChangeRequest( { language: value } );
  }

  render() {
    const { language, languages, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <DropDown
        id="lang-switcher"
        name="lang-switcher"
        options={languages}
        value={language}
        label={formatMessage(messages.choose_language_label)}
        onChange={this.handleChange}
        valueSelector={(option: ILanguage) => option.language}
      />
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      language: state.checkout.intlData.locale,
    }),
    {
      languageChangeRequest,
    }
  ),
)(LangSwitcher);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/LangSwitcher/LangSwitcher.tsx